"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var DESTROYED_NOTIFIER_NAME = '_componentDestroyedNotifier$';
function DestroyableComponent(target) {
    var targetPrototype = target.prototype;
    var originOnDestroy = targetPrototype.ngOnDestroy;
    targetPrototype[DESTROYED_NOTIFIER_NAME] = new Subject_1.Subject();
    targetPrototype.ngOnDestroy = function () {
        originOnDestroy && originOnDestroy();
        targetPrototype[DESTROYED_NOTIFIER_NAME].next(true);
        targetPrototype[DESTROYED_NOTIFIER_NAME].complete();
    };
}
exports.DestroyableComponent = DestroyableComponent;
function componentDestroyed(target) {
    return target[DESTROYED_NOTIFIER_NAME];
}
exports.componentDestroyed = componentDestroyed;
